class Commite {
    constructor(node) {
        this.node = node;
        this.toggler = node.querySelector('#commite-more');

        this.listen();
    }

    listen() {
        const { toggler, node } = this;
        if (!toggler) return;

        toggler.addEventListener('click', (e) => {
            e.preventDefault();

            const items = node.querySelectorAll('.commite__item.hidden');
            items.forEach((item) => {
                item.classList.remove('hidden');
            });

            toggler.classList.add('hidden');
        });
    }

    static init() {
        const node = document.querySelector('.commite');
        if (node) {
            new Commite(node);
        }
    }
}

export default Commite;
